<template>
  <div class="cricket-coverage">
    <loading-state :state="state"></loading-state>
    <div v-if="coverage" >
      <div class="coverage-selected">
        <div class="item clickable" @click="toggleShowSelection()">{{coverageSelected.board | capitaliseUpper}}</div>
         <div class="item clickable" @click="toggleShowSelection()" v-if="coverageSelected.child_boards">{{coverageSelected.child_boards}}</div>
        <div class="item clickable" @click="toggleShowSelection()" v-if="coverageSelected.season">{{coverageSelected.season | capitaliseUpper}}</div>
      </div>
      <div class="coverage-selection" v-if="showSelection">
        <div class="coverarge-tool" >
          <div class="item clickable" @click="updateSelection()">Update Selection</div>
        </div>
        <div class="coverage-list">
          <div class="boards">
            <ul>
              <li 
                v-for="board in coverage.boards"
                :key="board.key"
                class="clickable"
                :class="{active:board.key == coverageSelected.board}"
                @click="selectBoard(board)">
                <div>{{board.name}}</div>
                <div class="meta">{{board.is_international?'International':'Local'}}. {{board.region}}</div>
              </li>
            </ul>
          </div>
          <div class="competitions" v-if="coverage">
            <ul>
              <li v-for="childBoard in childBoards" :key="childBoard.key" :class="{active:childBoard.key == coverageSelected.child_boards}"
                class="clickable"
                @click="selectChildBoard(childBoard.key)">
                <div>{{childBoard.name}}</div>
                <div class="meta">{{childBoard.is_international?'International':'Local'}}. {{childBoard.region}}
                </div>
              </li>
            </ul>
          </div>
          <div class="year">
            <ul>
              <li
                :class="{active:coverageSelected.month == null}"
                class="clickable">
                All Time
              </li>
              <li
                v-for="month in months" :key="month"
                :class="{active:month == coverageSelected.month}"
                class="clickable"
                @click="MetricCricketCoverage.selectMonth(month)">
                <div class="meta">{{month}}</div>
              </li>
            </ul>
          </div>
          <div class="competitions">
            <ul>
              <li class="clickable" v-for="season in allSeasons"    @click="MetricCricketCoverage.selectSeason(season.key)"
                :class="{active:season.key == coverageSelected.season}" :key="season.key">
                {{season.name}}
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import moment from 'moment'
import { DataState, AppState } from '@/state'
import { MetricCricketCoverage } from '@/models/cricket/core'
import { coverageHome } from '@/models/cricket/core'
export default {
  props: {
    showVsTeam: {
      type: Boolean,
      default: true
    },
    isMetric: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      showSelection: false,
      coverage: null,
      seasons: null,
      MetricCricketCoverage: MetricCricketCoverage,
      coverageSelected: MetricCricketCoverage.State.selected,
      state: DataState.newNotInit(),
      months: null,
      childBoards: [],
      monthList: [],
      allSeasons: []
    }
  },
  computed: {
  },
  mounted () {
     if(!this.state.isLoading() && !MetricCricketCoverage.State.coverage) {
      this.loadCoverage()
    }

    if (MetricCricketCoverage.State.coverage && !this.coverage) {
      this.coverage = MetricCricketCoverage.State.coverage
    }
    
    this.allMonths()
  },
  methods: {
    loadCoverage () {
      this.state.changeToLoading()
      MetricCricketCoverage.State.fetch(this.isMetric).then((coverage) => {
        this.coverage = coverage
        this.state.changeToLoaded()
      }).catch((error) => {
        console.error(error)
        this.state.changeToError(error)
      })
    },

    selectBoard (board) {
      this.coverageSelected.board = board.key
      this.allSeasons = []
      if (!board.child_boards) {
        for (let month of this.monthList) {
          MetricCricketCoverage.selectBoardKey(board, month).then((seasons) => {
          for (let season in seasons) {
            const found = this.allSeasons.some(el => el.key === seasons[season].key)
            if (!found) {
              this.allSeasons.push(seasons[season])
            }
          }
            this.state.changeToLoaded()
          }).catch((error) => {
            console.error(error)
            this.state.changeToError(error)
          })
        }
      } else {
        for (let child of board.child_boards) {
          if (this.childBoards.indexOf(child) === -1) {
            this.childBoards.push(child)
          }
        }
      }
    },
    selectChildBoard (childKey) {
      this.coverageSelected.child_boards = childKey
        MetricCricketCoverage.selectChildBoards(childKey).then((seasons) => {
          this.seasons = seasons
          this.state.changeToLoaded()
        }).catch((error) => {
          console.error(error)
          this.state.changeToError(error)
        })
      },

    allMonths () {
      let allMonths = []
      var m = moment()
      for (var i = 0; i < 12; i++) {
        allMonths.push(m.month(i).format('YYYY-MM'))
      }
      this.months =  allMonths
      for (var i=1; i <=2; i++) {
        this.monthList.push(moment().subtract(i, 'months').format('YYYY-MM'))
      }
      for (var i=0; i <=5; i++) {
        this.monthList.push(moment().add(i, 'months').format('YYYY-MM'))
      }
    },

    toggleShowSelection () {
      this.showSelection = !this.showSelection
    },

    updateSelection () {
      const selected = MetricCricketCoverage.State.selected

      this.$router.push(selected.buildUrl('MetricSeason', selected.season))
      this.showSelection = false
    }
  }
}
</script>
